var _path, _path2, _path3, _g, _rect, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeductionsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_6240",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63541 23H16.9091C17.1985 23 17.476 22.8841 17.6806 22.6778C17.8852 22.4715 18.0001 22.1917 18.0001 21.9V6.5H12.5452V1H1.63541C1.34607 1 1.06857 1.11589 0.863974 1.32218C0.659376 1.52847 0.544434 1.80826 0.544434 2.1V21.9C0.544434 22.1917 0.659376 22.4715 0.863974 22.6778C1.06857 22.8841 1.34607 23 1.63541 23Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5452 1L18.0001 6.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27229 10.3501V18.0501M5.45386 14.2001H13.0907",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_6240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.8186 -1.19995H22.3649V25.2001H-3.8186V-1.19995Z",
    fill: "#2E8056"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 17.8524,
    height: 13,
    fill: "#2E8056"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45483 14.2H13.0917",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeductionsIcon);
export default __webpack_public_path__ + "static/media/deductionsIcon.b17c6dc5c517e542f26e919857590b96.svg";
export { ForwardRef as ReactComponent };